import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettings } from 'app/modules/shared/app.settings';
import type { Language } from 'app/modules/shared/models/language';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';

@Component({
  selector: 'app-input-int',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputNumberModule],
  templateUrl: './input-int.component.html',
  styleUrl: './input-int.component.scss'
})
export class InputIntComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  placeholder: any = null;
  unit: string = '';
  language: Language;
  languageCode: string;
  attributeCodesToCheck = ['radius_in_km']

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService, private metaDataService: MetaDataService) {
    this.formName = this.formGroupDirective.control;
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.languageCode = this.language[0].langCode;
  }

  ngOnInit() {
    if(this.field.attributeCode === 'visit_frequency') {
      const control = this.formName.controls.visit_frequency;
      
      if (control.value !== null && control.value !== undefined) {
        this.cs.emitDaysValue(control.value);
      }
      
      control.valueChanges.subscribe(change => {
        this.cs.emitDaysValue(change);
      });
    }
    this.onChangeLocationCategory();
    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, this.field.attributeCode);
    if (this.language && this.languageCode) {
      if (this.field) {
        const unit = this.metaDataService.systemOfMeasurement;
        const tempUnit = unit === 'Imperial' ? JSON.parse(this.field?.imperialUnit) : JSON.parse(this.field?.metricUnit);
        this.languageCode = this.language[0].langCode;
        if (tempUnit) {
          this.unit = tempUnit?.[this.languageCode];
        }
      }
    }
  }

  onChangeLocationCategory() {
    this.formName.controls.location_category?.valueChanges?.subscribe(value => {
      if (value === 'Parking') {
        this.field.validation.required = true;
      } else {
        this.field.validation.required = false;
      }
    });
  }
}